import { formatDateForMcleod } from "../utils/dateHelpers";

export default class CarrierPreferredLanesSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      __type: "recurring_available_tractor",
      company_id: "TMS",
      carrier_id: data.carrierId,
      location_city: data.originCity,
      location_state: data.originState,
      city_id: data.originCityId,
      load_to_city: data.destinationCity,
      load_to_state: data.destinationState,
      dest_city_id: data.destinationCityId,
      start_date: formatDateForMcleod(data.startDate),
      per_week: data.weekly,
      date_created: formatDateForMcleod(data.postedDate),
      created_by: data.postedBy,
      updated_by: data.updatedBy,
      end_date: formatDateForMcleod(data.endDate),
      proposed_cost: data.proposedCost,
      proposed_rpm: data.proposedRpm,
      lane_miles: data.miles,
      tractors_available_monday: data.availableDaily.availableMonday,
      tractors_available_tuesday: data.availableDaily.availableTuesday,
      tractors_availablewednesday: data.availableDaily.availableWednesday,
      tractors_available_thursday: data.availableDaily.availableThursday,
      tractors_available_friday: data.availableDaily.availableFriday,
      tractors_available_saturday: data.availableDaily.availableSaturday,
      tractors_available_sunday: data.availableDaily.availableSunday,
      equipment_type_id_sunday: data.equipmentTypeDaily.equipmentTypeSunday,
      equipment_type_id_monday: data.equipmentTypeDaily.equipmentTypeMonday,
      equipment_type_id_tuesday: data.equipmentTypeDaily.equipmentTypeTuesday,
      equipment_type_id_wednesday: data.equipmentTypeDaily.equipmentTypeWednesady,
      equipment_type_id_thursday: data.equipmentTypeDaily.equipmentTypeThursday,
      equipment_type_id_friday: data.equipmentTypeDaily.equipmentTypeFriday,
      equipment_type_id_saturday: data.equipmentTypeDaily.equipmentTypeSaturday
    };

    const customProperties = [
      "carrierId",
      "originCity",
      "originState",
      "originCityId",
      "destinationCity",
      "destinationState",
      "destinationCityId",
      "startDate",
      "weekly",
      "postedDate",
      "postedBy",
      "updatedBy",
      "availableDaily",
      "equipmentTypeDaily",
      "endDate",
      "proposedCost",
      "proposedRpm", 
      "miles"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      originCity: data.locationCity,
      originState: data.locationState,
      originCityId: data.cityId,
      destinationCity: data.loadToCity,
      destinationState: data.loadToState,
      destinationCityId: data.destCityId,
      weekly: data.perWeek,
      postedDate: data.dateCreated,
      postedBy: data.createdBy,
      updatedBy: data.updatedBy,
      proposedCost: data.proposedCost,
      proposedRpm: data.proposedRPM,
      miles: data.laneMiles,
      availableDaily: {
        availableMonday: data.tractorsAvailableMonday,
        availableTuesday: data.tractorsAvailableTuesday,
        availableWednesday: data.tractorsAvailableWednesday,
        availableThursday: data.tractorsAvailableThursday,
        availableFriday: data.tractorsAvailableFriday,
        availableSaturday: data.tractorsAvailableSaturday,
        availableSunday: data.tractorsAvailableSunday,
      },
      equipmentTypeDaily: {
        equipmentTypeSunday: data.equipmentTypeIdSunday,
        equipmentTypeMonday: data.equipmentTypeIdMonday,
        equipmentTypeTuesday: data.equipmentTypeIdTuesday,
        equipmentTypeWednesady: data.equipmentTypeIdWednesday,
        equipmentTypeThursday: data.equipmentTypeIdThursday,
        equipmentTypeFriday: data.equipmentTypeIdFriday,
        equipmentTypeSaturday: data.equipmentTypeIdSaturday,
      }
    };
  }
}